import React from "react"
import "./chip.scss"

const Chip = ({ children, onClick, isActive, isCloseActive, key, slug = null, }) => {
    return slug ? (
        <a
            key={key}
            href={slug}
            className={`f-chip ${isActive ? "is-active" : ""}`}
        >
            {children}
            {isCloseActive && <i className="icon-times"></i>}
        </a>
    ) : (
        <button
            key={key}
            onClick={onClick}
            className={`f-chip ${isActive ? "is-active" : ""}`}
        >
            {children}
            {isCloseActive && <i className="icon-times"></i>}
        </button>
    )
}

export default Chip
